import styled from 'styled-components';

/**
 * A wrapper for `Dialog` header content
 * (content will automatically be wrapped when using the `header` prop).
 *
 * @related [`Dialog`]
 * @since 7.0.0
 */
var DialogHeader = /*#__PURE__*/styled.header.withConfig({
  displayName: "DialogHeader",
  componentId: "c11n-8-109-1__sc-1ace4ml-0"
})([""]);
DialogHeader.displayName = 'DialogHeader';

/** @component */
export { DialogHeader };